import '@va/styles/index.scss';
import '@va/styles/tailwind-base.css';
import '@va/styles/tailwind-components.css';
import '@va/styles/tailwind-utilities.css';
import AaasApp from 'aaas/App';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import 'react-loading-skeleton/dist/skeleton.css';
import './index.css';

// initializeSentry();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <AaasApp />
  </StrictMode>,
);
